import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/FilterList.svg?component
var FilterList_exports = /* @__PURE__ */ __exportAll({
	default: () => FilterList_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M4 6h16M7.556 12h8.888m-6.222 6h3.556"
	}, null, -1)])]);
}
var FilterList_default = { render: render$1 };
//#endregion
export { FilterList_exports, FilterList_default as default, render$1 as render };

//# sourceMappingURL=FilterList.svg_component.js.map